import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { BreadCrumb } from "primereact/breadcrumb";
import Axios from "axios";
import { DEV } from "../../services/constants";
import SofStop from "../../modals/SofStop";
import { handlePostRequest } from "../../services/PostTemplate";
import pageStyles from "./pendingPackage.module.scss";

function PendingPackage() {
    const [selectedRow, setselectedRow] = useState([]);
    const [packages, setPackages] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [role, setrole] = useState("");
    const dispatch = useDispatch();
    const history = useHistory();
    const [showSoftStop, setShowSoftStop] = useState(false);

    const [values, setValues] = useState({
        Waybill: "",
        name: "",
        status: "",
        flightNumber: "",
        merchant: "",
        date: "",
        consigneeName: "",
        trackingNumber: "",
        billTo: "",
        deliveryInfo: "",
        bill: "",
        weight: "",
        packageStatus: "",
        description: "",
    });

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 100,
        page: 1,
        sortField: null,
        sortOrder: null,
    });

    useEffect(() => {
        const role = localStorage.getItem("role");
        setrole(role);
    }, []);

    useEffect(() => {
        if (role) {
            loadPackages();
        }
    }, [lazyParams, values, role]);

    const loadPackages = async () => {
        setLoading(true);
        try {
            const response = await Axios.get(`${DEV}/pendingPackages`, {
                params: {
                    page: lazyParams.page,
                    limit: lazyParams.rows,
                    ...values,
                    sortField: lazyParams.sortField,
                    sortOrder: lazyParams.sortOrder,
                },
            });

            if (response?.data?.data) {
                setPackages(response.data.data.packages);
                setTotalRecords(response.data.data.total);
            }
        } catch (error) {
            console.error("Error loading packages:", error);
            toast.error("Failed to load packages");
        } finally {
            setLoading(false);
        }
    };

    const handleApplyFilter = (value, name) => {
        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));
        setLazyParams((prev) => ({
            ...prev,
            page: 1,
            first: 0,
        }));
    };

    const onPage = (event) => {
        setLazyParams((prev) => ({
            ...prev,
            first: event.first,
            rows: event.rows,
            page: event.page + 1,
        }));
    };

    const onSort = (event) => {
        setLazyParams((prev) => ({
            ...prev,
            sortField: event.sortField,
            sortOrder: event.sortOrder,
        }));
    };

    const handleFilter = (name) => {
        return (
            <input
                style={{ width: "100%", height: "37px", borderRadius: "5px", border: "none" }}
                value={values[name] || ""}
                onChange={(e) => handleApplyFilter(e.target.value, name)}
            />
        );
    };

    const handleDelete = async () => {
        if (!selectedRow?.length) {
            toast.error("Please select at least one package");
            return;
        }
        setShowSoftStop(true);
    };

    const onSuccessSoftStop = async () => {
        try {
            setShowSoftStop(false);
            const selectedIds = selectedRow.map((val) => val.Waybill);
            const response = await dispatch(handlePostRequest({ id: selectedIds }, "/deletePendingPackage", true, true));
            if (response?.success) {
                toast.success("Packages deleted successfully");
                loadPackages();
                setselectedRow([]);
            }
        } catch (error) {
            console.error("Error deleting packages:", error);
            toast.error("Failed to delete packages");
        }
    };

    const handleRecover = async () => {
        if (!selectedRow?.length) {
            toast.error("Please select at least one package");
            return;
        }
        try {
            const selectedIds = selectedRow.map((val) => val.Waybill);
            const response = await dispatch(handlePostRequest({ id: selectedIds }, "/recoverPackages", true, true));
            if (response?.success) {
                toast.success("Packages recovered successfully");
                loadPackages();
                setselectedRow([]);
            }
        } catch (error) {
            console.error("Error recovering packages:", error);
            toast.error("Failed to recover packages");
        }
    };

    return (
        <div className={pageStyles.pageWrapper}>
            <Dialog visible={showSoftStop} style={{ width: "650px" }} onHide={() => setShowSoftStop(false)}>
                <SofStop onHideSoftStop={() => setShowSoftStop(false)} onSuccessSoftStop={onSuccessSoftStop} type="package" />
            </Dialog>

            <div className="Page__Header">
                <div>
                    <h2>Pending Packages</h2>
                    <BreadCrumb
                        model={[{ label: "Home", url: "/" }, { label: "Packages" }]}
                        home={{ icon: "pi pi-home", url: "/" }}
                    />
                </div>
                {role === "admin" && (
                    <div className="Top__Btn">
                        <Button icon="pi pi-trash" iconPos="right" onClick={handleDelete} className="Btn__DarkDelete" style={{ width: "240px" }} />
                        <Button icon="pi pi-sync" iconPos="right" onClick={handleRecover} className="Btn__Blue" style={{ width: "240px" }} />
                    </div>
                )}
            </div>

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            value={packages}
                            lazy
                            paginator
                            first={lazyParams.first}
                            rows={lazyParams.rows}
                            totalRecords={totalRecords}
                            onPage={onPage}
                            onSort={onSort}
                            sortField={lazyParams.sortField}
                            sortOrder={lazyParams.sortOrder}
                            loading={loading}
                            selection={selectedRow}
                            onSelectionChange={(e) => setselectedRow(e.value)}
                            dataKey="Waybill"
                            className="datatable-responsive"
                            emptyMessage="No packages found."
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} packages"
                            rowsPerPageOptions={[100, 250, 500]}
                            filterDisplay="row"
                        >
                            <Column selectionMode="multiple" style={{ width: "3em" }} />
                            <Column field="Waybill" header="Way Bill" sortable filter filterElement={handleFilter("Waybill")} />
                            <Column field="billTo" header="Package Name" sortable filter filterElement={handleFilter("billTo")} />
                            {role === "admin" && (
                                <Column field="consigneeName" header="Consignee Name" sortable filter filterElement={handleFilter("consigneeName")} />
                            )}
                            <Column style={{width:"200px"}} field="trackingNumber" header="Tracking Number" sortable filter filterElement={handleFilter("trackingNumber")} />
                            <Column style={{width:"200px"}} field="merchant" header="Merchant" sortable filter filterElement={handleFilter("merchant")} />
                            <Column field="flightNumber" header="Flight Number" sortable filter filterElement={handleFilter("flightNumber")} />
                            <Column field="description" header="Description" sortable filter filterElement={handleFilter("description")} />
                            <Column field="deliveryInfo" header="Delivery Information" sortable filter filterElement={handleFilter("deliveryInfo")} />
                            <Column field="packageStatus" header="Package Status" sortable filter filterElement={handleFilter("packageStatus")} />
                            <Column field="weight" header="Weight" sortable body={(rowData) => `${rowData.weight.number} ${rowData.weight.unit}`} />
                            <Column field="date" header="Created On" sortable filter filterElement={handleFilter("date")} />
                            {role === "admin" && (
                                <Column
                                    body={(rowData) => (
                                        <Button
                                            icon="pi pi-ellipsis-v"
                                            className="p-button-rounded mr-2 Elipse_Icon"
                                            onClick={() => history.push(`package/${rowData.Waybill}`)}
                                        />
                                    )}
                                />
                            )}
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingPackage;
